import React, { useState } from 'react';
import { BsEnvelope } from 'react-icons/bs';
import { FaPhoneAlt } from 'react-icons/fa';
import { RiMailLine } from 'react-icons/ri';
import { Button, Modal } from 'react-bootstrap';
import './ContactMe.css';

function ContactMe() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="contact-button">
        <Button variant="success" onClick={handleShow}>
          <RiMailLine /> Contact Me
        </Button>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="contact-info">
            <h4 className="contact-subtitle text-center">Let's get in touch!</h4>
            <div className="contact-details">
              <p><span className="contact-detail-label"><FaPhoneAlt /> Phone:</span>9079121897</p>
              <p><span className="contact-detail-label"><RiMailLine /> Email:</span>madhavshuklasr3@gmail.com</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="warning"
            onClick={() =>
              window.location.href = `mailto:madhavshuklasr3@gmail.com`
            }
          >
            <BsEnvelope /> Send Email
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ContactMe;
